import { useUpgradeTierModalStore } from '../stores/upgradeTierModalStore';
export const openUpgradeTierModal = ({ resourceType, currentLimit, upgradeUrl, onClose } = {}) => {
  const { openUpgradeTierModal: openModal } = useUpgradeTierModalStore.getState();
  openModal({
    resourceType: resourceType || 'resources',
    currentLimit,
    upgradeUrl,
    onClose,
  });
};
